import styles from './step4-layout.module.css';

export const Step4Layout = ({
  children,
  bottomContent,
}: {
  children: React.ReactNode;
  bottomContent: React.ReactNode;
}) => {
  return (
    <div className={styles.contentContainer}>
      <div className={styles.mainContent}>{children}</div>
      <div className={styles.bottomContent}>{bottomContent}</div>
    </div>
  );
};
